import React, { Component } from "react";
import FilterSelectAddFilterButton from "./FilterSelectAddFilterButton";
import { isPropsForLogicalOperator } from "./LogicalOperatorsOptions";

/**
 * Allow to inject value A and B for between operator
 */
class LogicalOperatorIsBetweenView extends Component {
  constructor(props) {
    super();
    this.state = isPropsForLogicalOperator(props)
      ? props.logicalOperator.value
      : {
          valueA: "",
          valueB: "",
        };
  }

  onChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  /**
   * Set the value in the current Filter
   */
  onApplyFilter = () => {
    this.props.onApplyFilter && this.props.onApplyFilter(this.state);
  };

  render() {
    return (
      <>
        <div className="p-2 filter-container">
          <div className="form-row">
            <div className="col">
              <input
                type="text"
                id="valueA"
                value={this.state.valueA}
                className="form-control form-control-sm"
                placeholder="Value"
                onChange={this.onChange}
              />
            </div>
            <div className="col-1 p-0">
              <label className="filter-column-label">AND</label>
            </div>
            <div className="col">
              <input
                type="text"
                id="valueB"
                value={this.state.valueB}
                className="form-control form-control-sm"
                placeholder="Value"
                onChange={this.onChange}
              />
            </div>
          </div>
        </div>
        <FilterSelectAddFilterButton
          disabled={
            this.state.valueA.trim().length === 0 ||
            this.state.valueB.trim().length === 0
          }
          onClick={this.onApplyFilter}
        />
      </>
    );
  }
}

export default LogicalOperatorIsBetweenView;
